
	var WineTimer = {
		currentTime : "",
		endTime : "",
		diffTime : "",
		timerInterval : null,
		init : function() {
			WineTimer.remainTimeCheckInit();
		},
		remainTimeCheckInit : function(){
			if ($("#endTime").length > 0) {
				var endTimeVal = (typeof $("#endTime").val() == "undefined" ? "" : $("#endTime").val());
				if (endTimeVal != "") {
					endDate = $('#endTime').val();
//					endDate = "20210223180000";
					currentTime = new Date();
					endTime = new Date(eval(endDate.substring(0,4)), eval(parseInt(endDate.substring(4,6), 10) - 1), eval(endDate.substring(6,8)), eval(endDate.substring(8,10)), eval(endDate.substring(10,12)), eval(endDate.substring(12)));
					diffTime = parseInt(((endTime.getTime() - currentTime.getTime())/1000)+0.999,10);
					if (diffTime > 0) {
						// 타임세일 영역 노출
						$('#todayTimeSaleTop, #todayTimeSaleBottom').show(); 
						if (WineTimer.timerInterval != null) {
							clearTimeout(WineTimer.timerInterval);
						}
						WineTimer.remainTimeCheck();
					} 
				}
			} else {
				clearTimeout(WineTimer.timerInterval);
			}
		},
		remainTimeCheck : function() {
			tmpTime		= diffTime;									// 초계산
			viewSec		= tmpTime % 60;
			if(viewSec < 10){viewSec="0" + viewSec;}				// 이부분은 초단위에 한자리 숫자일때 앞에 0을 포함시키는것
			
			tmpTime		= parseInt(tmpTime / 60, 10);				// 분계산
			viewMinute	= tmpTime % 60;
			if(viewMinute < 10){viewMinute="0" + viewMinute;}		// 이부분은 분단위에 한자리 숫자일때 앞에 0을 포함시키는것
			
			viewHour	= parseInt(tmpTime / 60, 10);				// 시계산
//			viewHour	= tmpTime % 24;
			if(viewHour < 10){viewHour="0" + viewHour;}				// 이부분은 시단위에 한자리 숫자일때 앞에 0을 포함시키는것
			
//			if(viewHour > 99){
//				remainTimeText = '99:59:59';
//			}else{
				remainTimeText = viewHour +':' +viewMinute + ':' + viewSec;
//			}
			// 남은시간 노출
			$("#timeSaleRemain").text(remainTimeText);
			
			diffTime -= 1;
			if (diffTime >= 0) {
				timerInterval = setTimeout(function(){WineTimer.remainTimeCheck()}, 1000);
			} else {
				if (timerInterval != null) {
					clearTimeout(timerInterval);
				}
				// 타임세일 영역 비노출
				$('#todayTimeSaleTop, #todayTimeSaleBottom').hide();
			}
		}
	}
	
	WineTimer.init();
	
